import { useState, useEffect } from "react"
import RcmpHeader from "../../atoms/Header"
import RcmpLoading from "../../atoms/Loading"
import intl from "react-intl-universal"
import ContentBlank from "../../molecules/ContentBlank"
import IconCiq from "../../../assets/icons/CIQIcon"
import { listEquipmentSigma } from "../../../services/sigma"
import styles from "./index.module.scss"
import TabsSelectedPanels from "../../organisms/TabsSelectedPanels"
import { fnCanAtLeast } from "../../../utils/permissions"
import { useNavigate } from "react-router-dom"
import SigmaDefault from "./components/SigmaDefaulf"

export default function SigmaPage() {
  const [isLoading, setIsLoading] = useState(false)
  const [equipmentSigma, setEquipmentSigma] = useState([])
  const [cSearch, setCSearch] = useState("")

  const navigate = useNavigate()

  const aBreadCrumbs = [
    {
      path: "./",
      name: intl.get("home"),
    },
    {
      bActive: true,
      name: intl.get("ciq.title"),
    },
  ]

  const fnListEquipmentSigma = async (cSearch) => {
    try {
      setIsLoading(true)

      const resp = await listEquipmentSigma(cSearch)
      setEquipmentSigma(resp.data.data)
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fnListEquipmentSigma(cSearch)
  }, [cSearch])


  return (
    <SigmaDefault setCSearch={setCSearch}>
      <div className={styles.wrapperAvaliation}>
        <div className={styles.wrapperEquipment}>
          {isLoading ? (
            <RcmpLoading bShow={true} size={60} />
          ) : (
            equipmentSigma.map((equipment) => {
              return (
                <button
                  className={styles.containerEquipment}
                  key={equipment.equipment_nid}
                  onClick={() => {
                    navigate(`/ciq/sigma/list-analytes-in-equipment/${equipment.equipment_nid}`)
                  }}
                >
                  {equipment.equipment_cname}
                </button>
              )
            })
          )}
        </div>
      </div>
    </SigmaDefault>
  )
}
